import { combineReducers, createStore, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import {
  branches,
  explore,
  homeTree,
  graph,
  graphFilter,
  projects,
  user
} from 'Reducers'
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2'

rootPersistConfig = {
  key: 'root'
  storage
  blacklist: [ 'branches', 'explore', 'projects', 'homeTree' ] # don't persist this
  stateReconciler: autoMergeLevel2
}

projectsPersistConfig = {
  key: 'projects'
  storage
  whitelist: ['currentProject', 'displayConfigEnabled']
  stateReconciler: autoMergeLevel2
}

explorePersistConfig = {
  key: 'explore'
  storage
  whitelist: ['hideChangelog']
  stateReconciler: autoMergeLevel2
}

rootReducer = combineReducers({
  branches
  explore: persistReducer(explorePersistConfig, explore)
  homeTree
  graph
  graphFilter
  projects: persistReducer(projectsPersistConfig, projects)
  user
})

export store = createStore(
  persistReducer(rootPersistConfig, rootReducer),
  # add this for thunk capabilities
  # (ie to allow functions as action creators, instead of being obliged to pass actions directly)
  applyMiddleware(thunk)
)

window.store = store

export persistor = persistStore(store)

if window.Cypress
  window.test ?= {}
  window.test.store = store
